<div class="d-flex flex-column bg-login m-0">
  <div class="w-25 mx-auto">
    <div class="card px-2">
      <div class="card-header text-center">
        <div class="mx-auto logo-login mb-4"></div>
        <h5 class="mb-1">{{ "DCO.Password_SetPasswordTitle" | translate }}<!-- Establecer contraseña --></h5>
        <p class="text-muted">{{ "DCO.Login_SetPasswordDescription" | translate
          }}<!--Configura tu usuario y contraseña para acceder al portal --></p>
      </div>
      <div class="card-body">
        <form class="mb-5" *ngIf="!isLoggedIn">
          <div *ngIf="!passwordResetOk">
            <div class="form-group mb-4">
              <label class="form-label fw-semibold mb-2" for="username"> {{ "DCO.Login_UserName" | translate
                }}<!-- Introduce usuario --></label>
              <input type="username" class="form-control" [(ngModel)]="userLocal" name="user" />
            </div>
            <div class="form-group mb-4">
              <label class="form-label fw-semibold mb-2" for="username">{{ "DCO.Password_Reset_NewPassword" | translate
                }}<!-- Añadir contraseña --></label>
              <input type="password" class="form-control" [(ngModel)]="userPassword" name="pw" />
            </div>
            <div class="form-group mb-4">
              <label class="form-label fw-semibold mb-2" for="username">{{ "DCO.Password_Reset_ConfirmPassword" |
                translate }}<!-- Confirmar contraseña --></label>
              <input type="password" class="form-control" [(ngModel)]="userConfirmPassword" name="confirmpw" />
            </div>
            <div class="alert alert-danger" *ngFor="let error of error">
              {{error}}
            </div>
            <p class="text-muted">{{ "DCO.Password_Reset_Info" | translate
              }}<!--Al aceptar se enviará un correo de confirmación de acceso al Servicio de Gestión de Reclamaciones DClaims. En caso de no recibir dicho correo o de cualquier duda no dudes en ponerte en contacto con nosotros --></p>
            <div class="form-group mb-3">
              <button type="submit" class="btn btn-dark rounded-2 w-100 m-0" (click)="resetPW()">
                {{ "DCO.Password_Reset_Accept" | translate }}
              </button>
              <div *ngIf="blockButton" class="d-flex justify-content-center" style=" left: 50%">
                <div class="spinner-border spinner-border-smtext-customer"></div>
              </div>
            </div>
          </div>
          <div class="alert alert-success" *ngIf="passwordResetOk">
            {{ "DCO.Password_Reset_Successful" | translate }}
          </div>
          <div class="form-group">
            <button *ngIf="passwordResetOk" type="submit" class="btn btn-outline-dark rounded-2 w-100 m-0"
              (click)="NavigateLogin()">
              {{ "DCO.Login_LoginButton" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>